import script from "./RacingRightSidebarFixtureOdd.vue?vue&type=script&setup=true&lang=js"
export * from "./RacingRightSidebarFixtureOdd.vue?vue&type=script&setup=true&lang=js"

import "./RacingRightSidebarFixtureOdd.vue?vue&type=style&index=0&id=09d7ed48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09d7ed48"]])

export default __exports__